import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import {
  provideAppShell,
  provideShellTitleStrategy,
  withNoMatchRedirect,
} from '@sbe-spinoff-client/app-shell';
import {
  provideSchoolbellOrgLinkApiBaseUrl,
  provideSpinoffAuth,
  resolveOrgScopedId,
  spinoffAuthInterceptor,
} from '@sbe-spinoff-client/spinoff-platform';
import { appRoutes } from './app.routes';
import { conductApiBaseUrlInterceptor } from './core/api/conduct-api-base-url.interceptor';
import { conductErrorNoticeInterceptor } from './core/api/conduct-error-notice.interceptor';
import { environment } from './environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    // The only login method is "학교종이로 로그인" (the API disables local auth routes).
    provideSpinoffAuth({
      apiBaseUrl: environment.conductApiBaseUrl,
      methods: [],
      oidcProviders: [
        {
          id: 'schoolbell',
          label: $localize`:@@conductLoginSchoolbell:학교종이로 로그인`,
          startUrl: `${environment.conductApiBaseUrl}/auth/sso/schoolbell-e/authorize-redirect`,
        },
      ],
      loginPath: '/login',
      // Requests under `/orgs/:orgId/...` carry the school-scoped token (POST /auth/org-token).
      resolveOrgScopedId,
    }),
    // The 학교종이 「진입」 callback (ErpCallbackComponent) posts its token to this API.
    provideSchoolbellOrgLinkApiBaseUrl(() => environment.conductApiBaseUrl),
    provideHttpClient(
      withInterceptors([
        conductApiBaseUrlInterceptor,
        spinoffAuthInterceptor,
        conductErrorNoticeInterceptor,
      ]),
    ),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      // 단체 라우트 프리픽스 표준(conventions-angular-practices.md 「단체·팀 라우트 프리픽스」).
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withNoMatchRedirect(),
    ),
    {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: { fontSet: 'material-symbols-outlined' },
    },
    provideAppShell({
      brandText: $localize`:@@conductBrand:상벌점 관리`,
      brandLogo: '/images/conduct-bell.svg',
    }),
    provideShellTitleStrategy(),
  ],
};
